module.exports = __webpack_public_path__ + "img/icon-about-2.d4a38782.png";